import { LoanEndDateExpirationError } from './CustomErrors'

export class ManifestValidator {
  constructor (manifest) {
    this.manifest = manifest
  }

  get validated () {
    if (!this.manifest) {
      throw new Error('Manifest not found')
    }

    if (!this.manifest.metadata || !this.manifest.links || !this.manifest.spine) {
      throw new Error('Manifest not valid')
    }

    if (this.loanEndDateHasExpired()) {
      throw new LoanEndDateExpirationError(
        this.manifest.metadata.title, 'Loan end date has expired'
      )
    }

    return this.manifest
  }

  loanEndDate () {
    let rights = this.manifest.metadata['http://www.feedbooks.com/audiobooks/rights']
    if (!rights) return
    return rights.end
  }

  loanEndDateHasExpired () {
    let loanEndDate = this.loanEndDate()
    if (!loanEndDate) return false
    if (new Date(loanEndDate).getTime() > new Date().getTime()) return false
    return true
  }
}



// WEBPACK FOOTER //
// ./src/lib/ManifestValidator.js